import { render, staticRenderFns } from "./page-cancelOrder-popup.vue?vue&type=template&id=25801168&scoped=true&"
import script from "./page-cancelOrder-popup.vue?vue&type=script&lang=js&"
export * from "./page-cancelOrder-popup.vue?vue&type=script&lang=js&"
import style0 from "./page-cancelOrder-popup.vue?vue&type=style&index=0&id=25801168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25801168",
  null
  
)

component.options.__file = "page-cancelOrder-popup.vue"
export default component.exports